import { useState } from "react";
import TextInput from "../components/ui/Input/TextInput";
import styles from "../components/EntityAddUpdateForm/EntityAddUpdateForm.module.css";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage(null);
    setSuccessMessage(null);

    if (!email) {
      setErrorMessage("Please enter your email address.");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const result = await response.json();

      if (result?.success) {
        setSuccessMessage("Reset link sent! Please check your email.");
      } else {
        const raw = result?.errors?.length
          ? result.errors.map((e: any) => Object.values(e).join(", ")).join(", ")
          : result?.message || "Failed to send reset link.";
        setErrorMessage(raw.replace(/^Error in [\w\s]+:\s*/i, ""));
      }
    } catch (err) {
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-columnwise">
      <div className="content-columnwise">
        <div className="center-container">
          <form onSubmit={handleSubmit} className={styles.entityChangePasswordForm}>
            <h2 className="form-title">Forgot Password</h2>
            <h5>Enter your email to receive a reset link</h5>

            <TextInput
              label="Email"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => { setErrorMessage(null); setSuccessMessage(null); setEmail(e.target.value); }}
            />

            {successMessage && <p className="success-message">{successMessage}</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}

            <div className={styles.buttonContainer}>
              <button type="submit" className={styles.entityAddUpdateForm__submitbtn} disabled={loading}>
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;